export default function mobMenuScrollTargetsTrigger(): void {
    const targets = document.querySelectorAll('._TARGET-SCROLL-MOB-MENU._show');

    targets.forEach((target) => {
        target.dispatchEvent(new Event('scroll'));
    });
}
